import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { navigateToHomepage } from '../../store/history/history.actions'
import { selectIsMapFullScreen } from '../../store/map/map.selectors'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import UserButton from '../UserAccount/UserButton'
import { useAction } from '../utils/react-redux'
import s from './DesktopPreHeader.less'
import ItineraryUniverseButton from './ItineraryUniverseButton'

const DesktopPreHeader = () => {
  const isMapFullScreen = useSelector(selectIsMapFullScreen)

  const execNavigateToHomepage = useAction(navigateToHomepage)
  const onClickToHomepage = useCallback(
    e => {
      e.preventDefault()
      execNavigateToHomepage()
    },
    [execNavigateToHomepage]
  )

  const shouldDisplayUserAccount = useSelector(selectIsUserAccountEnabled)

  return (
    <div className={s.root}>
      {shouldDisplayUserAccount && !isMapFullScreen && <UserButton />}
      <a href="/" className={s.logo} title="Mappy" onClick={onClickToHomepage}>
        Mappy
      </a>
      {!isMapFullScreen && (
        <div className={s.universeButtons}>
          <ItineraryUniverseButton />
        </div>
      )}
    </div>
  )
}

export default DesktopPreHeader
